import React, { FC } from "react"
import styles from "./picape-proud.module.scss"
import { Conditional, CTAButton, SectionElement } from "@/components"
import { dataMenuLabels, links } from "@/data/menu.data"
import scssStyles from "@utils/scssStyles"



const PicapeProudSection: FC = () => {
  const reference = dataMenuLabels().find((c) => c.slug === "off-road")

  return (
    <div className={styles.container}>
      <SectionElement
        id="photoSection"
        className={scssStyles([styles.box, styles.red])}
        navReference={reference}
      >
        <div className={styles.content}>
          <div className={styles.contentTitle}>
            <h2 className={styles.title}>
              Versatilidade para <br/>
              Qualquer desafio
            </h2>

            <p>
              Motor turbo, tecnologia e conforto tanto para o lazer <br /> quanto para o trabalho. A picape que enfrenta qualquer <br /> desafio. Veja as ofertas e garanta a sua.
            </p>
          </div>

          <a target="_blank" href={links.picapes} >
            <div className={styles.universal_cta}>Aproveitar Ofertas</div>
          </a>

        </div>
      </SectionElement>
    </div>
  )
}

export default PicapeProudSection
